import scFileSelect from '@/components/scFileSelect';
export default {
    emits: [
        'success',
        'closed'
    ],
    components: {
        scFileSelect
    },
    props: {
        max: {
            type: Number,
            default: 9
        },
        multiple: {
            type: Boolean,
            default: false
        },
        hideUpload: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            visible: false,
            file: ''
        };
    },
    mounted () {},
    methods: {
        //显示
        open () {
            this.visible = true;
            return this;
        },
        //表单提交方法
        submit (value) {
            this.$emit("success", value);
            this.visible = false;
        }
    }
};
